
import { createReducer } from '@reduxjs/toolkit' ;
import { authenticateUserRequest, authenticateUserFailure, authenticateUserSuccess, refreshTokenRequest, refreshTokenRequestSuccess, refreshTokenRequestFailure, restoreUserSession, resetPasswordRequestSuccess, resetPasswordRequest, resetPasswordRequestFailure, tempPasswordRequest, tempPasswordRequestFailure, tempPasswordRequestSuccess, forgetPasswordEmailRequest, forgetPasswordEmailRequestSuccess, forgetPasswordEmailRequestFailure, confirmForgotPasswordRequestFailure, confirmForgotPasswordRequestSuccess, confirmForgotPasswordRequest, confirmForgotPasswordReset, loadingInProgress, clearResetPasswordStatus } from '../actions/loginServiceAction';

const initialState = {
    idToken: null,
    accessToken: null,
    refreshToken: null,
    expiresIn: 0,
    aggregator: '',
    isAdmin: false,
    userAuthorized: false,
    loginResponse: null,
    refreshLogic : false,
    tokenTime: null,
    userName: '',
    emailId: '',
    merchantId: '',
    merchantName: '',
    resetPasswordStatus: null,
    tempPasswordResponse : null,
    forgetPasswordEmailResponse : null,
    confirmForgotPasswordResponse : null,
    apiCallInProgress: false
};

const loginServiceReducer = createReducer(initialState, (builder) => {
    builder
        .addCase(authenticateUserRequest, (state, action) => {
        }).addCase(authenticateUserSuccess, (state, action) => {
            state.idToken = action.payload.data.idToken;
            sessionStorage.setItem('merchantAuth', 'true');
            state.accessToken = action.payload.data.accessToken;
            state.refreshToken = action.payload.data.refreshToken;
            state.expiresIn = action.payload.data.expiresIn;
            state.aggregator = action.payload.data.aggregator;
            state.isAdmin = action.payload.data.isAdmin;
            state.refreshLogic = false;
            state.loginResponse = {...action.payload.data, tokenTime: new Date()};
            state.userAuthorized = true;
            state.tokenTime = new Date();
            state.userName = action.payload.data.userName;
            state.emailId = action.payload.data.emailId;
            state.merchantId = action.payload.data.merchantId;
            state.merchantName = action.payload.data.merchantName;
        }).addCase(authenticateUserFailure, (state, action) => {
            state.userAuthorized = false;
            state.loginResponse = { msg: 'ERROR',details: action.payload.data };
            state.tokenTime = null;
        }).addCase(restoreUserSession, (state, action)=> {
            state.refreshLogic = true;
            state.userAuthorized = true;
            sessionStorage.setItem('merchantAuth', 'true');
            state.idToken = {...action.payload.tMer}.idToken;
            state.refreshToken = {...action.payload.rMer}.refreshToken;
            state.tokenTime = new Date();
            state.accessToken = {...action.payload.cMer}.accessToken;
            state.expiresIn = {...action.payload.cMer}.expiresIn;
            state.aggregator = {...action.payload.cMer}.aggregator;
            state.merchantId = {...action.payload.cMer}.merchantId;
            state.merchantName = {...action.payload.cMer}.merchantName;
            state.isAdmin = {...action.payload.cMer}.isAdmin;
            state.loginResponse = {...action.payload.cMer, ...action.payload.tMer, ...action.payload.rMer};
            state.userName = {...action.payload.cMer}.userName;
            state.emailId = {...action.payload.cMer}.emailId;
            state.userAuthorized = true;
        })
        .addCase(resetPasswordRequest, (state, action) => {
            action.refreshToken = state.refreshToken;
            action.accessToken = state.accessToken;
        }).addCase(resetPasswordRequestSuccess, (state, action) => {
            state.resetPasswordStatus = action.payload.data;
        }).addCase(resetPasswordRequestFailure, (state, action) => {
            state.resetPasswordStatus = {msg: 'Error', details: action.payload.data}
        }).addCase(clearResetPasswordStatus, (state, action) => {
            state.resetPasswordStatus = null
        })

        .addCase(refreshTokenRequest, (state, action) => {
        }).addCase(refreshTokenRequestSuccess, (state, action) => {
            state.idToken = action.payload.data.idToken;
            state.accessToken = action.payload.data.accessToken;
            state.userAuthorized = true;
            state.refreshLogic = true;
            state.loginResponse = {
                ...state.loginResponse,
                idToken: action.payload.data.idToken,
                accessToken: action.payload.data.accessToken,
                tokenTime: new Date()
            };
            state.tokenTime = new Date();
        }).addCase(refreshTokenRequestFailure, (state, action) => {
            state.userAuthorized = false;
            state.loginResponse = { msg: 'ERROR', details: action.payload.data };
            state.tokenTime = null;
        })

        .addCase(tempPasswordRequest, (state, action) => {
        }).addCase(tempPasswordRequestSuccess, (state, action) => {
            state.tempPasswordResponse = action.payload.data
        }).addCase(tempPasswordRequestFailure, (state, action) => {
            state.tempPasswordResponse = { msg: 'ERROR', details: action.payload.data };
        })
        .addCase(forgetPasswordEmailRequest, (state, action) => {
            state.userName = action.payload.userName;
        }).addCase(forgetPasswordEmailRequestSuccess, (state, action) => {
            state.forgetPasswordEmailResponse = action.payload.data
        }).addCase(forgetPasswordEmailRequestFailure, (state, action) => {
            state.forgetPasswordEmailResponse = { msg: 'ERROR', details: action.payload.data };
        })
        .addCase(confirmForgotPasswordRequest, (state, action) => {
        }).addCase(confirmForgotPasswordRequestSuccess, (state, action) => {
            state.confirmForgotPasswordResponse = action.payload.data
        }).addCase(confirmForgotPasswordRequestFailure, (state, action) => {
            state.confirmForgotPasswordResponse = { msg: 'ERROR', details: action.payload.data };
        }).addCase(confirmForgotPasswordReset, (state, action) => {
            state.confirmForgotPasswordResponse = null
        }).addCase(loadingInProgress, (state, action) => {
            state.apiCallInProgress = action.payload.data;
            // console.log('DD ',action);
        });
    builder.addDefaultCase((state) => state);
});

export default loginServiceReducer;
